<template>
  <portal-target v-bind="$attrs">
  </portal-target>
</template>

<script>

export default {
  name: "AppPortalTarget",
};
</script>